module.exports = __webpack_public_path__ + "static/media/Regret.db5b0209.png";